var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1611_69857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.667 80.0002C146.667 116.817 116.817 146.667 80.0006 146.667C43.184 146.667 13.334 116.817 13.334 80.0002C13.334 43.1835 43.184 13.3335 80.0006 13.3335C116.817 13.3335 146.667 43.1835 146.667 80.0002Z",
    fill: "#CAC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.452 14.576L63.8613 100.281L77.4202 113.347L160.011 27.6422L146.452 14.576Z",
    fill: "#5A53DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.986 33.7231L63.8594 100.286L77.416 113.35L139.166 49.2565C136.193 43.5465 132.416 38.3165 127.986 33.7231Z",
    fill: "#5A53DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9129 60.8925L36.877 74.4805L77.4245 113.38L90.4604 99.7925L49.9129 60.8925Z",
    fill: "#8983F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1611_69857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTickIcon);
export default __webpack_public_path__ + "static/media/success-tick-icon.85b72bcb9b0b4e85e7d8d6ed008bce17.svg";
export { ForwardRef as ReactComponent };